'use client';
import { type FC, useEffect } from 'react';
import { useLoggedIn } from '@/tracking/use-logged-in';
import type { TrackingState } from '../app/oekostrom-vario-checkout/schema';
import { useDataDog } from './use-data-dog-rum';
import { useTrackVirtPathAndPageMeta } from './use-track-virt-path-and-page-meta';

type TrackingProps = {
  dataDogViewName: string;

  state: TrackingState;
  virtPathViewName: string;
};

export const Tracking: FC<TrackingProps> = ({ dataDogViewName, state, virtPathViewName }) => {
  const trackVirtPathAndPageMeta = useTrackVirtPathAndPageMeta();

  const loggedIn = useLoggedIn();

  useDataDog({
    checkout: 'Vario',
    viewName: dataDogViewName,
    state,
  });

  useEffect(() => {
    trackVirtPathAndPageMeta(
      `${loggedIn ? '/serviceview' : ''}/checkout-b2c-strom-${virtPathViewName.replace(' ', '-').toLocaleLowerCase()}-vario/`,
      `${loggedIn ? 'Serviceview ' : ''}Checkout B2C Strom ${virtPathViewName} Vario`,
      'Other',
    );
  }, [loggedIn, trackVirtPathAndPageMeta, virtPathViewName]);

  return null;
};
